import React, { useRef, useState, useEffect,useContext } from 'react'
import { Container, Box, Typography, Button } from '@mui/material'
import img from '../assets/img.png'
import WeCear from '../components/WeCear'
import Cards from '../components/Cards'
import { HomeData, cards } from '../assets/data'
import Footer from "../components/Footer"
import { Link, useLocation, useNavigate } from 'react-router-dom'
import useMediaQuery from "@mui/material/useMediaQuery";
import ImagesLogo from '../components/ImagesLogo'
import FaqSection from '../components/FaqSection'
import Sliceimg from '../assets/Slice.png'
import mobiimg from "../assets/mobil.png"
import { useSnackbar } from "notistack";
import Lottie from 'react-lottie';
import animationData from '../assets/a1.json'
import { AppContext } from "../context/ContenxtAPI";

const Home = () => {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { boilerService } = useContext(AppContext)
  const [showAnimation, setShowAnimation] = useState(true);
  const query = new URLSearchParams(window.location.search);
  const success = query.get('success');
  const cancel = query.get('cancel');
  const navigate = useNavigate();
  const mainCardsDivRef = useRef(null);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }

  };
  const scrollToCards = () => {
    if (mainCardsDivRef.current) {
      mainCardsDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  if (success) {
    enqueueSnackbar("Your subscription has been created successfully. We will inform you through email.", { variant: 'success' });
  } else if (cancel) {
    enqueueSnackbar("Your subscription has been cancelled. Please feel free to try again.", { variant: 'error' });
  }
  useEffect(() => {

    if (location.state?.fromAboutUs || location.state == true) {
      scrollToCards();
      navigate('/', { replace: true, state: {} });
    }
    boilerService();
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [location, scrollToCards]);

  const match140 = useMediaQuery("(max-width:480px)");
  const matches = useMediaQuery('(max-width:500px)');
  // if (showAnimation) {
  //   return (
  //     <div className="center-animation">
  //       <Lottie
  //         options={defaultOptions}
  //         height={400}
  //         width={400}
  //       />
  //     </div>
  //   );
  // }
  return (
    <>

      <Box className="Hero_main" style={{ backgroundImage: matches ? `url(${mobiimg})` : `url(${Sliceimg})`, height: matches ? '100vh' : '120vh' }} >
        <Box className="hero_div">
          <h1 className='herotitle'>
            WeCare about<br /> your boiler, your home<br /> and about you!
          </h1>
          <Link >
            <Button variant="contained" className='herobtn1' onClick={scrollToCards} >
              WeCare Cover Plans
            </Button>
          </Link>
        </Box>
      </Box>
      <Container maxWidth="xl" className='containers'>
        <Box className="flexDivs">
          <Box className="sec2div">
            <p className='second_titles_home'>
              At WeCare, we understand the <br /> importance of a warm, safe, and  <br />well-maintained home. As a leading <br /> provider of boiler repair and home <br /> care services, we take pride in being <br /> your trusted partner in ensuring <br /> your home remains comfortable <br /> and secure, all year round.
            </p>
            <Link to='/About'> <Button variant="contained" className="herobtn">Read Our Story</Button></Link>
          </Box>
          <Box className="imgdiv">
            <img src={img} alt="" />
          </Box>
        </Box>
      </Container>
      <Box className="containers">
        <WeCear />
      </Box>
      {
        showAnimation ? (
    <div className="center-animation" id="boilerServices">
    <Lottie
      options={defaultOptions}
      height={400}
      width={400}
    />
  </div>
    ): (
      < Box className="main_Cards_divs"  ref={mainCardsDivRef}>
      <div className="card_inner_div" id="boilerServices">
        <Typography variant="h4" className='card_text_h4' pb={2}> <span style={{ color: "#604CD4" }}>WeCare</span> Cover Plans</Typography>
        <Cards cards={cards} />
      </div>
    </Box >
    )
}
      <div className='faqs_in_home'>
        <FaqSection FAQS={HomeData} />
      </div>
      <Box className="maincenter">
        <h1 className='its_h1'>It’s simple and easy to switch<br /> your home plan to us today!</h1>
        <Link>
          <Button variant="contained" className="herobtn" onClick={scrollToCards}>
            Get a Quote
          </Button></Link>
      </Box>
      <div>
        <ImagesLogo />
      </div>

      <Footer />
    </>
  )
}

export default Home
